<script lang="ts">
	export let tag: string;
</script>

<a data-sveltekit-reload href={`/tags/${tag}`} class="tag" aria-label="Posts tagged with {tag}"
	>#{tag}</a
>

<style lang="postcss">
	@reference "../../app.css";

	.tag {
		@apply inline-block px-2.5 py-0.5 mr-2 mb-2 border border-border rounded-full text-text-secondary font-medium text-xs no-underline bg-surface-secondary transition-all duration-200;
	}

	.tag:hover {
		@apply border-primary text-primary;
	}
</style>
